import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import ProductsProductsListComponent from "./ProductsList";
import Registration from "./Registration";
import Confirmation from "./Confirmation";
import Login from "./Login";
import MyAccount from "./MyAccount";
import ContactForm from "./ContactForm";
import Voucher from "./Voucher";
import { Container } from "react-bootstrap";
import { CSSTransition } from 'react-transition-group'
import apiService from "./services/api.service";
import { useTranslation } from "react-i18next";
import "./i18n/config";
import i18next from "i18next";
import Modal from 'react-modal';
import LoginComponent from "./Login";
import { useForm } from "react-hook-form";
import ShoppingCartComponent from "./ShoppingCart";
import { useSelector, useDispatch } from "react-redux";
import { addItem } from "./Redux/shoppingCartReducer";
import { setUser } from "./Redux/userReducer";
import CurrentProductComponent from "./CurrentProduct";
import StorageSessionService from "./services/storage.service";





function App() {

  const routes = [
    { path: '/product', name: 'Products', Component: CurrentProductComponent },
    { path: '/registrastion', name: 'Registration', Component: Registration },
    { path: '/confirmation', name: 'Confirmation', Component: Confirmation },
    { path: '/login', name: 'Login', Component: Login },
    { path: '/myaccount', name: 'My Account', Component: MyAccount },
    { path: '/contact', name: 'Contact Form', Component: ContactForm },
    { path: '/gv', name: 'Get Voucher', Component: Voucher },
    { path: '/', name: 'Home', Component: ProductsProductsListComponent }

  ]

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
  });


  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const [lang, setLang] = useState("");
  const { t } = useTranslation();
  const chainId = urlParams.get("chainid") || 0;
  const [thisAccountCustomer, setThisAccountCustomer] = useState(null);
  const [modalTermsIsOpen, setModalTermsIsOpen] = useState(false);

  const [modalShoppingCartIsOpen, setModalShoppingCartIsOpen] = useState(false);
  const itemsFromRedux = useSelector((state) => state.cart.items);
  const productsFromSession = window.sessionStorage.getItem("products");
  const loggedUser = useSelector((state) => state.user.user)
  const items = productsFromSession ? JSON.parse(productsFromSession) : itemsFromRedux;
  const dispatch = useDispatch();
  const companyUser = useSelector((state) => state.company.companyUser)


  const SetLanguage = (l) => {
    i18next.changeLanguage(l);
  };

  useEffect(() => {
    if (chainId && !sessionStorage.getItem("chain")) {
      apiService.getChains(chainId)
        .then(response => {
          if (!response.errors && response.data && response.data.data) {
            sessionStorage.setItem("chain", JSON.stringify(response.data.data[0]))
          }
        })
    }
  }, [chainId])

  useEffect(() => {
    if (!Object.keys(itemsFromRedux).length && Object.keys(items).length) {
      for (let i in items) {
        for(let k = 0; k < items[i].qty; k++){
          dispatch(addItem({ selectedProduct: items[i].selectedProduct }));
        }
      }
    }
  }, [])

  useEffect(() => {
    setLang(urlParams.get("lang") || "eng");
    if (loggedUser) {
      findCustomer(loggedUser.email, loggedUser.id, true);
    }else{
      setThisAccountCustomer(null)
    }

    if (window.parent !== window.self) {
      window.parent.postMessage({ iframe_loaded: true }, '*');
      console.info('dispatch event to loaded event!');
    }
  }, [loggedUser]);

  useEffect(() => {
    SetLanguage(lang);
  }, [lang]);

  const findCustomer = (email, customerId, isGetOrders) => {

    apiService.getCustomer(email).then(
      (response) => {

        if (response.data.data && response.data.data.length > 0) {
          var custId = response.data.data[response.data.data.length - 1].customerId;
          if (custId !== customerId) {

          }
          else {
            setThisAccountCustomer(response.data.data[response.data.data.length - 1]);

            if (window.location.href.includes("contact") && !window.location.href.includes("cxl=1")) {
              goToMyAccount();
            }
          }
        }

      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );

  }
  const logout = () => {
    dispatch(setUser(null))
    setThisAccountCustomer(null)
    window.location.href = `/?chainid=${chainId}&lang=${urlParams.get("lang") || "eng"}`;
  }

  const login = () => {

    setModalTermsIsOpen(true);
  }

  const openCart = () => {

    setModalShoppingCartIsOpen(true);
  }


  const goToMyAccount = () => {
    window.location.href = `/myaccount?chainid=${chainId}&lang=${urlParams.get("lang") || "eng"}`;
  }

  const getItemsInCartCount = () => {
    let count = 0;
    if (items) {

      for (let key of Object.keys(items)) {

        count += items[key].qty;

      }
    }
    return count;
  }

  return (
    <Router>
      <>
        <Container className="container">
          {routes.map(({ path, Component }) => (
            <Route key={path} exact path={path}>
              {({ match }) => (
                <CSSTransition
                  in={match != null}
                  timeout={300}
                  classNames="opacity-node"
                  unmountOnExit>
                  <div className="page" id="main-page">
                    {
                      !companyUser &&
                      <div className="my-account-wrap row">
                        {thisAccountCustomer && !window.location.href.includes("myaccount") && !window.location.href.includes("gv") ?
                          <div className="col-10"><span className="greeting_txt"></span>{(t("hello") + " " + thisAccountCustomer.customerFirstName + " " + thisAccountCustomer.customerLastName + ",")} <span className="logout" onClick={e => goToMyAccount()}>{t("goToMyAccount")}</span> , <span className="logout" onClick={e => logout()}>{t("logout")}</span></div>
                          :
                          !window.location.href.includes("login") && !window.location.href.includes("myaccount") && !window.location.href.includes("gv") ? (<div className="col-10 not-logged-in"><span className="greeting_txt"></span>{(t("hello") + " " + t("guest") + " ,")}  <span className="logout" onClick={e => login()}>{t("loginBtn")}</span></div>) : null
                        }
                        <div className="top-cart-wrap col-2 hidden" onClick={e => openCart()}>
                          <div className="ttl-items"> {getItemsInCartCount()}</div>
                          <div className="cart-ttl">{t("shopCart")}</div>

                        </div>
                      </div>

                    }
                    <Component />
                    {
                      //dont show logo in voucher page
                      !window.location.href.includes("/gv") &&
                      <div className="simplexLogo"></div>
                    }
                    <Modal
                      isOpen={modalTermsIsOpen}
                      contentLabel=""
                      className='login-modal'  >
                      <div className="modal-header">
                        <button type="button" className="close" onClick={e => setModalTermsIsOpen(false)}><span aria-hidden="true">×</span></button>

                      </div>
                      <div className="modal-body" >
                        <LoginComponent popupLogin="true"></LoginComponent>
                      </div>
                    </Modal>
                    <Modal
                      isOpen={modalShoppingCartIsOpen}
                      contentLabel=""
                      className='login-modal'  >
                      <div className="modal-header">
                        <button type="button" className="close" onClick={e => setModalShoppingCartIsOpen(false)}><span aria-hidden="true">×</span></button>

                      </div>
                      <div className="modal-body" >
                        <ShoppingCartComponent
                          register={register}
                          errors={errors}
                          handleSubmit={handleSubmit}
                          topCart={true}
                        ></ShoppingCartComponent>
                      </div>
                    </Modal>

                  </div>
                </CSSTransition>
              )}
            </Route>
          ))}
        </Container>
      </>
    </Router>

  );
}

export default App;